import { render } from "./Photo.vue?vue&type=template&id=bb12debe&scoped=true&lang=pug"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=bb12debe&scoped=true&lang=scss"
import "./Photo.vue?vue&type=style&index=1&id=bb12debe&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb12debe"]])

export default __exports__